import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RouteLayout } from '@web/app/components'

export const Route = createFileRoute('/_index/cuenta')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Cuenta',
      hidden: true,
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
<Outlet />
    </RouteLayout>
  )
}
